import type { BuildCaptionTurnsOptions } from 'features/call/call-captions/helpers';

export const CAPTION_DISPLAY_LD_FLAG_KEY = 'asrVoiceCaptions';

export interface CaptionDisplayConfig {
  enabled: boolean;
  captionDisplayPauseThresholdMs: number;
  sendToPeer: boolean;
}

type CaptionDisplayFlagValue = Partial<CaptionDisplayConfig> | undefined | null;

export const getCaptionDisplayConfigFlag = (
  flags: Record<string, unknown>
): CaptionDisplayFlagValue => {
  const asrVoiceCaptions = flags[CAPTION_DISPLAY_LD_FLAG_KEY];
  if (asrVoiceCaptions && typeof asrVoiceCaptions === 'object') {
    return asrVoiceCaptions;
  }

  return undefined;
};

export const DEFAULT_CAPTION_DISPLAY_CONFIG: CaptionDisplayConfig = {
  enabled: false,
  captionDisplayPauseThresholdMs: 3000,
  sendToPeer: false,
};

export const resolveCaptionDisplayConfig = (
  flagValue: Partial<CaptionDisplayConfig> | undefined | null
): CaptionDisplayConfig => ({
  enabled: flagValue?.enabled ?? DEFAULT_CAPTION_DISPLAY_CONFIG.enabled,
  captionDisplayPauseThresholdMs:
    flagValue?.captionDisplayPauseThresholdMs ??
    DEFAULT_CAPTION_DISPLAY_CONFIG.captionDisplayPauseThresholdMs,
  sendToPeer:
    flagValue?.sendToPeer ?? DEFAULT_CAPTION_DISPLAY_CONFIG.sendToPeer,
});

export const getCaptionTurnBuildOptions = (
  config: CaptionDisplayConfig
): BuildCaptionTurnsOptions => {
  const mergeOnPause = config.captionDisplayPauseThresholdMs === 0;

  return {
    mergeOnPause,
    pauseThresholdMs: mergeOnPause
      ? DEFAULT_CAPTION_DISPLAY_CONFIG.captionDisplayPauseThresholdMs
      : config.captionDisplayPauseThresholdMs,
  };
};
